module.exports = __webpack_public_path__ + "img/Zhou.a7289aac.png";